<template>
  <div>
    <template v-if="!$Tools.empty(courseOutline.children)">
      <div class="course_subChapter" v-for="(sitem, sindex) in courseOutline.children" :key="sindex"
        :class="{ expanded: sitem.isExpanded }">
        <div class="course_one" :class="[sitem.isExpanded ? '' : 'course_one_max']">
          <div class="subChapter_top flex FlexBetween Flexalign" v-if="sitem.children">
            <div class="flex Flexalign subChapter_top_left toverflow">
              <el-tooltip class="box-item" effect="customized" :content="sitem.chapterName" placement="top"
                :show-after="1000" :show-arrow="false">
                <div class="subChapter_top_left_subChapter flex-1 toverflow" :class="[
                  selectLearningInfo.parentId == sitem.chapterId ? 'text_active' : '',
                ]">
                  {{ sitem.chapterName }}
                </div>
              </el-tooltip>
            </div>
          </div>
          <div class="subChapterList" v-else>
            <div class="subChapterList_one cursor_pointer">
              <div class="flex Flexalign flex-1 toverflow">
                <el-image class="show_wheel" :src="iconPath('show_wheel.png')"
                  @click="changeWheel(sitem.chapterId)" :class="[sitem.phaseVoList.length?'':'show_wheel_empty']"></el-image>
                <el-tooltip class="box-item" effect="customized" :content="sitem.chapterName" placement="top"
                  :show-after="1000" :show-arrow="false">
                  <div class=" toverflow" @click="changeWheel(sitem.chapterId)">
                    {{ sitem.chapterName }}
                  </div>
                </el-tooltip>

                <div class="free_view_box ml-10" v-if="sitem.freeLearning == 1">免费试学</div>
              </div>
              <div class="wheel_list" v-if="sitem.wheel">
                <div v-for="(wheel, wheelIndex) in sitem.phaseVoList" :key="wheelIndex">
                  <div class="wheel_one flex Flexalign FlexBetween px-20" :class="[
                    selectWheelValue == wheel.phaseId || courseValue == wheel.phaseId
                      ? 'active_subChapterList_one'
                      : '',
                  ]" @mouseenter="selectCourseWheel(wheel)" @mouseleave="selectCourseWheel('')"
                    v-if="wheel.enabled == 1">
                    <div class="flex Flexalign">
                      <el-image class="wheel_active" :src="iconPath('wheel_active.png')" v-if="
                        wheel.phaseId == selectWheelValue ||
                        courseValue == wheel.phaseId
                      "></el-image>
                      <div class="wheel_active" v-else></div>
                      <div class="ml-5">{{ phaseList[wheel.phaseId] }}</div>
                    </div>
                    <div class="btn_learn cursor_pointer" v-if="
                      (wheel.phaseId == selectWheelValue ||
                        courseValue == wheel.phaseId) &&
                      wheel.showLearningBtn &&
                      isAleadyJoin
                    ">
                      <div @click="goLearning(sitem.chapterId, wheel.phaseId, false, sitem)" v-if="
                        courseValue != wheel.phaseId ||
                        courseChapterId != sitem.chapterId
                      ">
                        开始学习
                      </div>
                      <div v-else>学习中</div>
                    </div>
                    <div class="btn_learn cursor_pointer" v-if="
                      (wheel.phaseId == selectWheelValue ||
                        courseValue == wheel.phaseId) &&
                      wheel.showLearningBtn &&
                      sitem.freeLearning == 1 &&
                      !isAleadyJoin
                    ">
                      <div @click="goLearning(sitem.chapterId, wheel.phaseId, false, sitem)" v-if="
                        courseValue != wheel.phaseId ||
                        courseChapterId != sitem.chapterId
                      ">
                        免费试学
                      </div>
                      <div v-else>学习中</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="sitem.children">
          <courseTitleList :courseOutline="sitem" :courseValue="courseValue" :courseChapterId="courseChapterId"
            @changeCourseValue="changeCourseValue" @changeCourseValueToLearning="changeCourseValueToLearning"
            @showWheel="showWheel">
          </courseTitleList>
        </div>
      </div>
    </template>
    <template v-if="$Tools.empty(courseOutline.children)">
      <div class="subChapterList">
        <div class="subChapterList_one cursor_pointer">
          <div class="flex  Flexalign flex-1 toverflow">
            <el-image class="show_wheel" :src="iconPath('show_wheel.png')"
              @click="changeWheel(courseOutline.chapterId)" :class="[courseOutline.phaseVoList.length?'':'show_wheel_empty']"></el-image>
            <el-tooltip class="box-item" effect="customized" :content="courseOutline.chapterName" placement="top"
              :show-after="1000" :show-arrow="false">
              <div class=" toverflow" @click="changeWheel(courseOutline.chapterId)">
                {{ courseOutline.chapterName }}
              </div>
            </el-tooltip>

            <div class="free_view_box ml-10" v-if="courseOutline.freeLearning == 1">免费试学</div>
          </div>
          <div class="wheel_list" v-if="courseOutline.wheel">
            <div v-for="(wheel, wheelIndex) in courseOutline.phaseVoList" :key="wheelIndex">
              <div class="wheel_one flex Flexalign FlexBetween px-20" :class="[
                selectWheelValue == wheel.phaseId || courseValue == wheel.phaseId
                  ? 'active_subChapterList_one'
                  : '',
              ]" @mouseenter="selectCourseWheel(wheel)" @mouseleave="selectCourseWheel('')"
                v-if="wheel.enabled == 1">
                <div class="flex Flexalign">
                  <el-image class="wheel_active" :src="iconPath('wheel_active.png')" v-if="
                    wheel.phaseId == selectWheelValue || courseValue == wheel.phaseId
                  "></el-image>
                  <div class="wheel_active" v-else></div>
                  <div class="ml-5">{{ phaseList[wheel.phaseId] }}</div>
                </div>
                <div class="btn_learn cursor_pointer" v-if="
                  (wheel.phaseId == selectWheelValue || courseValue == wheel.phaseId) &&
                  wheel.showLearningBtn &&
                  isAleadyJoin
                ">
                  <div @click="
                    goLearning(
                      courseOutline.chapterId,
                      wheel.phaseId,
                      false,
                      courseOutline
                    )
                    " v-if="
                      courseValue != wheel.phaseId ||
                      courseChapterId != courseOutline.chapterId
                    ">
                    开始学习
                  </div>
                  <div v-else>学习中</div>
                </div>

                <div class="btn_learn cursor_pointer" v-if="
                  (wheel.phaseId == selectWheelValue || courseValue == wheel.phaseId) &&
                  wheel.showLearningBtn &&
                  !isAleadyJoin &&
                  courseOutline.freeLearning == 1
                ">
                  <div @click="
                    goLearning(
                      courseOutline.chapterId,
                      wheel.phaseId,
                      false,
                      courseOutline
                    )
                    " v-if="
                      courseValue != wheel.phaseId ||
                      courseChapterId != courseOutline.chapterId
                    ">
                    免费试学
                  </div>
                  <div v-else>学习中</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { debounce } from "@/assets/utils/dbucTrtl";
export default {
  name: "GjkcH5CourseTitleList",
  props: {
    courseOutline: {},
    courseValue: {},
    courseChapterId: {},
    onceLoad:{}
  },
  computed: {
    ...mapState({
      selectLearningInfo: (state) => state.learning.selectLearningInfo,
      phaseList: (state) => state.learning.phaseList,
      selectedChapterInfo: (state) => state.learning.selectedChapterInfo,
      courseChapterList: (state) => state.learning.courseChapterList,
    }),
  },
  watch: {
    selectedChapterInfo: {
      handler() {
        if (!this.$Tools.empty(this.selectedChapterInfo)) {
          this.confirmNext();
        } else {
          return;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      selectWheelValue: "",
      isAleadyJoin: false,
    };
  },

  mounted() {
    this.hasAlreadyJoin();
  },

  methods: {
    confirmNext: debounce(
      function () {
        this.goLearning(
              this.selectedChapterInfo.chapterId,
              this.selectedChapterInfo.wheelId,
              true
            );
            setTimeout(() => {
              this.$store.commit("learning/setSelectedChapterInfo", {});
            }, 1500);
      },
      1000,
      false
    ),
    // 是否已参与学习（已购买）
    hasAlreadyJoin() {
      if(!this.onceLoad) return
      this.$Api.course
        .hasAlreadyJoin(this.courseOutline.courseId)
        .then((res) => {
          if (!this.$Tools.empty(res.data.data)) this.isAleadyJoin = true;
        })
        .catch(() => { });
    },
    // 收起课程大纲
    retractChapter(info) {
      info.isExpanded = !info.isExpanded;
    },
    changeWheel(chapterId) {
      this.$emit("showWheel", this.courseOutline.children, chapterId);
    },
    showWheel(nodes, chapterId) {
      this.$emit("showWheel", nodes, chapterId);
    },
    selectCourseWheel(info) {
      this.selectWheelValue = info?.phaseId;
    },
    // 选中章节
    selectCourseChapter(info) {
      this.$emit("changeCourseValue", info?.chapterId);
    },
    changeCourseValue(info) {
      this.$emit("changeCourseValue", info);
    },
    // 选中课程开始学习
    changeCourseValueToLearning(chapterId, wheelId) {
      this.$emit("changeCourseValueToLearning", chapterId, wheelId);
    },
    // 去学习
    goLearning(chapterId, wheelId, flag, info) {
      if (!flag) {
        if (this.$Tools.empty(this.selectedChapterInfo)) {
          this.$store.commit("learning/setSelectedChapterInfo", {});
        }
      }
      if (info) {
        // 新增判断，判断起始时间是否配置，配置起始时间需判断是否在该时间段，若在该时间段才可切换，否则不可以切换
        if (info.openEndTime && info.openBeginTime) {
          const startTime = new Date(info.openBeginTime).getTime();
          const endTime = new Date(info.openEndTime).getTime();
          const nowTime = new Date().getTime();
          if (nowTime >= startTime && nowTime < endTime) {
            console.log("");
          } else {
            this.$Dialog.toast("视频未到开放时间，请查看课表", { type: "warning" });
            return;
          }
        }
        // 若只配置开始时间
        if (info.openBeginTime && !info.openEndTime) {
          const startTime = new Date(info.openBeginTime).getTime();
          const nowTime = new Date().getTime();
          if (nowTime < startTime) {
            this.$Dialog.toast("视频未到开放时间，请查看课表", { type: "warning" });
            return;
          }
        }
        // 若只配置结束时间
        if (info.openEndTime && !info.openBeginTime) {
          const endTime = new Date(info.openEndTime).getTime();
          const nowTime = new Date().getTime();
          if (nowTime > endTime) {
            this.$Dialog.toast("视频未到开放时间，请查看课表", { type: "warning" });
            return;
          }
        }
      }
      // 新增主动触发学习进度结算更新（仅视频观看完成后调用该接口，此处添加防止后端切片统计不及时的问题，再次触发再去判断inputStatus状态是否为1）,视频资源存在的情况
      if (!this.$Tools.empty(this.selectLearningInfo?.chapterResource)) {
        this.$Api.course
          .settlementVideoSegment({
            resourceId: this.selectLearningInfo?.chapterResource.resourceId,
            startSeconds: 0,
            endSeconds: 0,
          })
          .then(() => {
            this.$emit("changeCourseValueToLearning", chapterId, wheelId);
          });
      } else {
        this.$emit("changeCourseValueToLearning", chapterId, wheelId);
      }
      // this.$Jump.href("/onlineLearning", { courseId });
    },
  },
};
</script>

<style lang="scss" scoped>
.course_subChapter {
  // max-height: 36px;
  // overflow: hidden;

  //   margin-top: 15px;
  //   margin-left: 40px;
  .course_one {
    // margin-top: 15px;
    // margin-left: 40px;
  }

  //   .course_one_max {
  //     max-height: 32px;
  //     overflow: hidden;
  //   }

  .subChapter_top {
    margin-top: 10px;

    .subChapter_top_left_subChapter {
      // margin-left: 5px;
      color: #333333;
      font-size: 18px;
      // font-weight: 600;
    }

    .text_active {
      color: #13d6aa;
    }
  }
}

.subChapterList {
  // margin-top: 10px;
  // margin-left: 40px;

  .subChapterList_one {
    line-height: 36px;
    color: #999999;

    .show_wheel {
      margin-right: 10px;
      width: 14px;
      height: 14px;
    }
    .show_wheel_empty{
      opacity: 0;
    }

    .select_play {
      margin-right: 10px;
      width: 18px;
      height: 18px;
    }

    .free_view_icon {
      width: 80px;
      margin: 0 10px;
    }

    .btn_learn {
      width: 80px;
      height: 28px;
      background: linear-gradient(90deg, #00d5c2, #00d498);
      border-radius: 17px;
      color: #ffffff;
      line-height: 28px;
      margin-right: 10px;
      text-align: center;
    }
  }

  .active_subChapterList_one {
    background: #fafcff;
    color: #13d6aa;
  }

  .wheel_list {
    .wheel_one {
      .wheel_active {
        width: 28px;
        height: 28px;
      }
    }
  }
}

.course_subChapter.expanded {
  max-height: none;
  overflow: visible;
  padding: 5px 0;
  /* 展开后高度 */
}

.free_view_box {
  width: 59px;
  height: 25px;
  background: #fe5e3c;
  border-radius: 45px 45px 45px 2px;
  font-size: 12px;
  color: #FFFFFF;
  line-height: 25px;
  text-align: center;
}
</style>
